import { Helmet } from 'react-helmet-async';
import React from 'react';
import requireAuth from '../../../lib/requireAuth.jsx';
import withRouterParams from '../../../lib/withRouterParams.jsx';

import ChangeImpactDetailContainer from '../../../containers/projects/ChangeImpactDetailContainer.jsx';

const ChangeImpactDetail = ({ changeImpactId, projectId }) => (
  <>
    <Helmet>
      <title>Change Impact | ChangeSync</title>
    </Helmet>

    <ChangeImpactDetailContainer
      changeImpactId={changeImpactId}
      projectId={projectId}
    />
  </>
);

ChangeImpactDetail.getInitialProps = ({ query }) => ({
  changeImpactId: Number(query.changeImpactId),
  projectId: Number(query.projectId),
});

export default requireAuth(withRouterParams(ChangeImpactDetail));
